// import
import cookie from "./cookie"

let allEventLog = {
	appThat: null,
	setAppThat: function(appThat){
		this.appThat = appThat;
		return this;
	}
}

allEventLog.alarmDataLogFn = function(response, service){
    let sessionStorageUrlData;
    //确认sessionStorage.urlData存在或赋予默认空对象
    try {
        if(sessionStorage.urlData){
            sessionStorageUrlData = JSON.parse(sessionStorage.urlData) || {};
        }else{
            sessionStorageUrlData ={}
        }
    }catch(e){
            sessionStorageUrlData ={}
    }

    try{
        let httpFn = {};
        let errorData = response;
        let errorDataCode= response.data.resultCode || response.data['subCode'];
        let errorDataStatus = errorData.status;
        let oldData = JSON.parse(response.config.data||'{}');
        let errorUrl = errorData.config.url.substring(1);
        if(errorUrl.indexOf(":") >= 0){
            errorUrl = errorUrl.split("://")[1];
        }

        let errorDataLog = {
                'request': response.config.url,
                //'http_host': location.host,
                //'http_user_agent':navigator.userAgent,
                "level_name": allEventLog.level_name_rule(response.config.url,errorDataCode,errorDataStatus),
                'message':errorData.data,
                // 'http_referer':location.href,
                'statusText':errorData.statusText,
                'status':errorDataStatus,
                "access_token": sessionStorageUrlData.access_token,
                //"Accept-Language": sessionStorage.langType,
                "loginCustomerId": sessionStorageUrlData.loginCustomerId,
                "resultCode": errorDataCode,
                "Channel":"flowMall-web-H5",
                ...oldData
            };
        httpFn.$http = service;
        console.log(errorDataLog,"allEventLog-alarmDataLogFn-53");

        allEventLog.requestLog( errorUrl, errorDataLog , httpFn);
    }catch(e){
    	try{
    		console.log(e,"allEventLog-alarmDataLogFn-57");
    		allEventLog.comingLog(e,httpFn,"WARN")	
    	}catch(e){}
    }
}

//payLog
allEventLog.requestLog =function(ComeinUrl, param ,that){
    ComeinUrl = "/mph5log/requestLog/"+ ComeinUrl;
    allEventLog.log(ComeinUrl , param , that);
}

//payLog
allEventLog.payLog =function(ComeinUrl, param ,that){
    ComeinUrl = "/mph5log/paylog/"+ ComeinUrl;
    allEventLog.log(ComeinUrl , param , that);
}


allEventLog.objectDatafiter = function(oldData){
	let newData= {};
	if(typeof oldData == "string"){
		try{
			newData = JSON.parse(oldData);	
		}catch(e){
			newData = {
				"errorData":oldData
			}
		}	
	}else if(typeof oldData == "object" ){
		newData = allEventLog.getObjectData(oldData);
	}
	return newData;
}

allEventLog.getObjectData= function(oldData){
	let newData= {};
	Object.getOwnPropertyNames(oldData).forEach(function(key) {
	    newData[key] = oldData[key]
	})
	return newData;
}

//进入url埋点
allEventLog.comingLog = function(oldData, that , level_name){
	let comingData={};

	try{
		comingData = allEventLog.objectDatafiter(oldData);
	}catch(e){
		comingData = allEventLog.objectDatafiter(e);
	}
	
	let ComeinUrl = "/mph5log/comingLog"+ location.pathname;
    let DataLog = {
            'request': ComeinUrl,
            //'http_host': location.host,
            //'http_user_agent':navigator.userAgent,
            "level_name": level_name||'info',
            'http_referer':location.href,
            "Accept-Language": sessionStorage.langType,
            "Channel":"flowMall-web-H5",
            ...comingData
        };
    
    console.log(DataLog,"allEventLog-comingLog-123");
    allEventLog.log(ComeinUrl , DataLog , that);
}

//All log
allEventLog.log = function (url , param ,that){
	let url_obj = param || {};
	if(!url_obj.level_name){
		url_obj.level_name = allEventLog.level_name_rule(url);
	}
	if(!url_obj.authToken){
		if(cookie.get("loginCustomerId")){
			url_obj.authToken ='true';
		}
	}
	
	let method = "post";
	let requestData = {
		    method:method,
		    url:url,
		    data:url_obj,
		    headers: {
		        'Accept': '*/*'
		    }
		};

	try{
		allEventLog.setAppThat(that).appThat.$http(requestData).catch(error => {});
	}catch(error){
		url_obj = encodeURIComponent(param,"allEventLog-log-141");
	};
	
}

allEventLog.level_name_rule = function(url,errorDataCode,errorDataStatus){
	//日本业务规则,公共方法允许暴露非当前版本业务

	//默认级别
	let default_level_name = "info";
	//设置级别
	let set_level_name = AlllevelConfig[url+'-'+(errorDataCode||errorDataStatus)];

	//设置级别存在使用-默认级别转为设置级别
	if(set_level_name){
		default_level_name = set_level_name;
	}

	if(url == "/webmps/payment/cashier/createorder"){
		//不设置即告警
		if(!set_level_name){
			default_level_name = "Alert";
		}
	}


	return default_level_name;
}



export default allEventLog;